import styled from 'styled-components';

export const WhatsappContainer = styled.div`
  background-color: #fef7d9;
  display: flex;
  padding: 20px 16px;
  justify-content: space-between;
  align-items: end;
  margin-top: 10px;
  p {
    color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
  }
  a {
    color: rgba(0, 0, 232, 0.8);
    font-weight: 500;
  }
  .haveMoreQues {
    padding-bottom: 8px;
  }
`;
export const WhatsappImage = styled.img`
  width: 36px;
  height: 36px;
  margin-right: 12px;
`;
